module.exports = "/images/project_mortgage.svg?20399bddd30bff013c5323d08f148aa8";